import React from 'react';
import { Switch, Case, Default } from 'react-if';
import PropTypes from 'prop-types';
import { wrapDisplayName } from 'recompose';
import LoadingView from '../../components/view-loading';
import ErrorPage from '../../components/page-error';
const withWait = (SubComponent, mandatory) => {
  const WithWait = _ref => {
    let {
      loading,
      error,
      ...passThroughProps
    } = _ref;
    return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Case, {
      condition: !!loading
    }, () => /*#__PURE__*/React.createElement(LoadingView, null)), /*#__PURE__*/React.createElement(Case, {
      condition: !!mandatory && !!error
    }, () => /*#__PURE__*/React.createElement(ErrorPage, {
      error: error
    })), /*#__PURE__*/React.createElement(Default, null, () => /*#__PURE__*/React.createElement(SubComponent, passThroughProps)));
  };
  WithWait.propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.object
  };
  WithWait.displayName = wrapDisplayName(SubComponent, 'withWait');
  return WithWait;
};
export default withWait;